module.exports = __webpack_public_path__ + "img/1_2.d821a758.jpg";